var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voltar-ao-topo hidden-print"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Voltar ao topo'),expression:"'Voltar ao topo'"}],staticClass:"btn btn-success btn-circle",attrs:{"type":"button"},on:{"click":_vm.voltarAoTopo}},[_c('i',{staticClass:"fa fa-arrow-up"})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32837baf","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/componentes/VoltarAoTopo.vue
// module id = 1950
// module chunks = 0